
@if (calendarEvents?.length > 0) {
  <full-calendar #calendar [options]='calendarOptions'  deepChangeDetection="true" ></full-calendar>
}
